import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Select, Tag, Tooltip } from 'antd';
import React, { useMemo } from 'react';
import { useGroupedFieldOptions } from '../../../../../hooks/useGroupedFieldOptions';

const TargetField = ({
  selectedField,
  handleUpdateSelectedField,
  onSourceFieldChange,
}) => {
  const { groupedFieldOptions } = useGroupedFieldOptions();

  const showSourceField = useMemo(() => {
    return selectedField.transformation_type === 'simple';
  }, [selectedField]);

  const displayLabelTypeAndDescription = () => {
    const colors = {
      text: 'blue',
      number: 'green',
      list: 'purple',
    };

    const formatLower = selectedField?.format?.toLowerCase();
    const color = colors[formatLower] || 'default';
    const description = selectedField?.description;

    return (
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* translate=yes: hors du sous-arbre traduit du formulaire, permet de traduire le libellé métier */}
        <span translate="yes">{selectedField?.target_field_label}</span>

        {description && (
          <Tooltip title={description}>
            <InfoCircleOutlined style={{ cursor: 'help' }} />
          </Tooltip>
        )}
        <Tag color={color}>{selectedField?.format}</Tag>
      </span>
    );
  };

  return (
    <div style={{ marginTop: 16 }}>
      <span
        style={{
          fontSize: 16,
          fontWeight: 600,
          display: 'block',
          marginBottom: 8,
        }}
      >
        Champ cible
      </span>
      <div style={{ display: 'flex', gap: 16 }}>
        {/* TODO: move target field into drawer title and remove code below */}
        <Form.Item
          name="targetField"
          style={{
            flex: showSourceField ? 1 : 'auto',
            width: showSourceField ? 'auto' : '100%',
            marginBottom: 0,
          }}
          initialValue={selectedField.target_field}
        >
          <Select
            placeholder="Sélectionnez un champ"
            value={selectedField.target_field}
            labelRender={displayLabelTypeAndDescription}
            onChange={(value) =>
              handleUpdateSelectedField('targetField', value)
            }
            disabled={true}
          />
        </Form.Item>
        {showSourceField && (
          <Form.Item
            name={['simple', 'source_field']}
            style={{ flex: 1, marginBottom: 0 }}
            rules={[
              {
                required: true,
                message: 'Veuillez sélectionner un champ source',
              },
            ]}
            initialValue={selectedField.transformation?.simple?.source_field}
          >
            <Select
              placeholder="Sélectionnez un champ source"
              showSearch
              optionFilterProp="label"
              options={groupedFieldOptions}
              onChange={onSourceFieldChange}
              optionRender={(option) => (
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {option.label}
                  {option.data.metric && <Tag>{option.data.metric}</Tag>}
                </span>
              )}
              allowClear
            />
          </Form.Item>
        )}
      </div>
    </div>
  );
};

export default TargetField;
